module.exports = __webpack_public_path__ + "static/media/image.ee87781b.webp";